export class FilterMask {
  public mask1: number;
  public mask2: number;

  constructor(filterMask1: number, filterMask2: number) {
    this.mask1 = filterMask1 >>> 0;
    this.mask2 = filterMask2 >>> 0;
  }

  public equals(other: FilterMask): boolean {
    return other.mask1 === this.mask1 && other.mask2 === this.mask2;
  }

  public or(other: FilterMask): FilterMask {
    const filter = new FilterMask(0, 0);
    filter.mask1 = (this.mask1 | other.mask1) >>> 0;
    filter.mask2 = (this.mask2 | other.mask2) >>> 0;
    return filter;
  }

  public and(other: FilterMask): FilterMask {
    const filter = new FilterMask(0, 0);
    filter.mask1 = (this.mask1 & other.mask1) >>> 0;
    filter.mask2 = (this.mask2 & other.mask2) >>> 0;
    return filter;
  }

  public xor(other: FilterMask): FilterMask {
    const filter = new FilterMask(0, 0);
    filter.mask1 = (this.mask1 ^ other.mask1) >>> 0;
    filter.mask2 = (this.mask2 ^ other.mask2) >>> 0;
    return filter;
  }

  public lessThan(other: FilterMask): boolean {
    if (this.mask2 < other.mask2) {
      return true;
    } else if (this.mask2 === other.mask2) {
      if (this.mask1 < other.mask1) {
        return true;
      }
    }
    return false;
  }
}

export class EntitiesFilter {
  public mask: FilterMask;

  constructor(filterMask: FilterMask) {
    this.mask = filterMask;
  }

  public equals(other: EntitiesFilter): boolean {
    return other.mask.equals(this.mask);
  }

  public get hashCode(): number {
    return this.mask.mask1 | this.mask.mask2;
  }
}
